<template>
    <div id="playground_container" class="playground-container">
        <section class="playground">
            <div class="sandbox"
                 :style="{ width: options.width + 20 + 'px', height: options.height + 20 + 'px' }"
            >
                <div class="shadowboard"
                     :class="{'on': options.shadowBoard}"
                     :style="background">
                </div>

                <svg version="1.1"
                     xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     overflow="visible"
                     xml:space="preserve"
                     class="clipboard"
                     :width="options.width"
                     :height="options.height"
                     :viewBox="'0 0 ' + options.width + ' ' + options.height"
                     :enable-background="'new 0 0 ' + options.width + ' ' + options.height">

                    <clipPath id="clip-path">
                        <polygon id="polygon" :points="clipPoints" />
                    </clipPath>

                    <g clip-path="url(#clip-path)">
                        <image :width="options.width"
                               :height="options.height"
                               :xlink:href="images[selectedImage].source">
                        </image>
                    </g>
                </svg>

                <handles @updateHandle="updateHandle"
                         :shape="shape"
                         :coords="coords"
                         :options="options">
                </handles>
            </div>
        </section>

        <slot name="bottom"></slot>
    </div>
</template>

<script type="text/babel">
    import NProgress from 'nprogress';
    import Handles from './Handles';

    export default {
        props: {
            viewport: Object,
            shape: Object,
            coords: Array,
            options: Object,
            images: Array,
            selectedImage: Number,
        },

        computed: {
            background() {
                let src = this.images[this.selectedImage].source, img = new Image();

                img.onload = () => {
                    NProgress.done();
                    NProgress.remove();
                };

                img.src = src;

                return { 'background-image': 'url(' + src + ')' };
            },

            clipPoints() {
                let vm = this;

                return this.coords.map(i => {
                    return i.map((o, key) => {
                        if (0 === key) {
                            return (o / 100) * vm.options.width;
                        } else {
                            return (o / 100) * vm.options.height;
                        }
                    }).join(',');
                }).join(' ');
            }
        },

        components: {
            Handles
        },

        methods: {
            updateHandle(payload, percental) {
                this.$emit('updateHandle', payload, percental);
            },

            removeImage() {
                this.$emit('removeImage');
            }
        }
    }
</script>

<style lang="scss">
    @import "../../assets/scss/utilities/colors";
    .is--playground-image{
        width: 100%;
        height: 100%;
    }

    .playground-container {
        position: relative;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        -webkit-touch-callout: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        height: 100%;
        width: 100%;

        @media (min-width: 800px) {
            border-radius: 0 0 2px 2px;
        }

        .playground {
            position: relative;
            /*padding: 0 0 1rem;*/
            user-select: none;

            .sandbox {
                position: relative;
                border: 1px solid $brand-primary;
                /*margin: 20px auto 0;*/
                touch-action: none;
                user-select: none;

                .handles {
                    user-select: none;

                    .handle.draggable {
                        user-select: none;

                        &:after {
                            user-select: none;
                        }
                    }
                }

                .clipboard, .shadowboard {
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    right: 10px;
                    bottom: 10px;
                    background: transparent center center;
                    background-size: cover;
                }

                .shadowboard {
                    pointer-events: none;
                    opacity: 0;
                    transition: opacity .375s;

                    &.on {
                        opacity: .25;
                    }
                }
            }
        }

        .has--playground-actions {
            padding-top: 1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ClipPath/Playground.vue